import { Box, IconButton, TextField, makeStyles } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import React, { useState } from 'react'

const useStyle = makeStyles(() => ({
  input: {
    '& input::-ms-reveal': {
      display: 'none'
    },
    ['& input::-ms-clear']: {
      display: 'none'
    }
  },
  button:{
    position:'absolute',
    right:0,
    bottom:'10px',
    background:'white'
  }
}))
const PasswordInput = ({ ...rest }) => {
  const classes = useStyle()
  const [type, setType] = useState('password')
  return (
    <Box display={'flex'} alignItems={'center'} position={'relative'}>
      <TextField {...rest} type={type} className={classes.input} />
      <IconButton size='small' className={classes.button} onClick={() => setType((prev) => prev === 'password' ? 'text' : 'password')}>
        {type === 'password' ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </Box>
  )
}

export default PasswordInput
